import cn from 'classnames';
import type { ReactNode, SyntheticEvent } from 'react';
import React from 'react';

import { Heading } from '@sravni/react-design-system/lib/Typography';

import type { IClientMicrocreditListItem } from '@src/@types/clienttypes';

import type { LightweightCardContentProps } from './components';
import { CardContentItem, CardLogo } from './components';
import styles from './LightweightCardView.module.scss';

interface Props {
  offer: IClientMicrocreditListItem;
  customContent?: ReactNode;
  content?: LightweightCardContentProps[];
  badge?: ReactNode;
  actions: ReactNode;
  pixelDisplay?: ReactNode;
  isPromoCard?: boolean;
  onCardClick?: (e: SyntheticEvent) => void;
}

export const LightweightCardView = ({
  customContent,
  offer,
  pixelDisplay,
  content,
  badge,
  actions,
  isPromoCard,
  onCardClick,
}: Props) => {
  const { organization, advertising, isBankPartner } = offer;

  return (
    <div
      className={cn(styles.container, {
        [styles.clickable]: !!onCardClick,
        [styles.cardWithPromo]: !!isPromoCard,
      })}
      onClick={onCardClick}
      data-qa="Card"
    >
      <div className={styles.header}>
        <CardLogo
          logo={organization?.logotypes?.android || organization?.logotypes?.square}
          isPartner={isBankPartner || advertising?.isPartner}
        />

        <Heading className={styles.text} level={5} as="div">
          {organization.name}
        </Heading>
      </div>
      {badge && badge}

      <div className={styles.content}>
        {customContent && customContent}
        {content?.map((props) => <CardContentItem {...props} key={props.label} />)}
      </div>
      {pixelDisplay}
      {actions}
    </div>
  );
};
